import { Controller } from "@hotwired/stimulus";
import { post } from "@rails/request.js";

export default class extends Controller {
  static targets = ["dismissForm", "chatForm"];

  async submit() {
    await post(this.dismissFormTarget.action, {
      body: new FormData(this.dismissFormTarget),
    });

    this.chatFormTarget.requestSubmit();
  }
}
